import React, { useContext, useEffect } from 'react'
import { InputData } from '../style'
import { companyComponentsProps } from '../DisponibilityComponent'
import axios from 'axios'
import { FeedbackContext } from '../../../contexts/FeedbackContext'

const InsertCEPComponent:React.FC<companyComponentsProps> = (props) => {
  const { company, setCompany } = props
  const { setFeedback } = useContext(FeedbackContext)
  
  useEffect(() => {
    if(company.cep.length === 9){
      axios.post(`${process.env.REACT_APP_COMPANIES_BASE_URL}/address/cep`, {cep:company.cep})
        .then(response => {
          if(response.data){
            setCompany(prev => ({
              ...prev,
              state:response.data.state,
              city:response.data.city,
              neighborhood:response.data.neighborhood,
              street:response.data.street
            }))
          }
          return
        })
        .catch(error => {
          console.error(error)
          setFeedback({
            isOpen:true,
            message:'Erro ao consultar o cep',
            statusOk:false
          })
        })
    }
  }, [company.cep])

    const maskCEP = (value:any) => {
      return value
        .replace(/\D/g, '') 
        .replace(/^(\d{5})(\d)/, '$1-$2') 
        .slice(0, 9) 
    }
  
  return(
    <InputData 
      placeholder={'00000-000'}
      onChange={(e) => setCompany(prev => ({...prev, cep:e.target.value}))}
      value={maskCEP(company.cep)}
    />
  )
}

export default InsertCEPComponent